import type { FaireProductEntity } from "../../entity_types/product";

export const p_aatpyr755w: FaireProductEntity = {
  token: "p_aatpyr755w",
  type: "product",
  name: "Film Snob Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/a4531fa9782013ee982d3eadc9aff92a91559bbdcb1c983ac6499b6a280e9104.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/785a2e39bc29c689f12645f374756b065f47e443b632acfefc4d256e00920daf.jpeg",
    "https://cdn.faire.com/fastly/ba752b26f090dda58945e68f880cd33e4dfb4674187e7bc3c59ff1bf10e915d8.jpeg",
    "https://cdn.faire.com/fastly/3939c9867e98def82bdff61083c489236c52c57662dbda2375eed30b3a29605d.jpeg",
    "https://cdn.faire.com/fastly/10046b9a51207d03a6bc45d36e9aa1ab42eb0d754cd97b33e7f0bfe107796931.jpeg"
  ],
  priceDollars: 6.75,
  description: "If they think Nolan is pedantic, and Lanthimos is a hack, but their Letterboxd is sacred? Buy them these socks and then maybe pop on Love Island for 'em, just to see the look on their face. 😝\n\nGumball Poodle is GPSR compliant!\n\nWe will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:06.896Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
